import React from 'react'
import styled from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'

import Spacer from '~/components/Spacer'
import Center from '../basic/Center'
import Link from "~/components/Link"
import Layout from './Layout'
import List from './List'
import PERKS from './PERKS'
import QUALITIES from './QUALITIES'

const LAYOUT_COLUMNS = {
  fullCol: {
    lg: 12,
    md: 12,
    sm: 12,
    xs: 12
  },
  intro: {
    left: {
      lg: 6,
      md: 6,
      sm: 6,
      xs: 12
    },
    right: {
      lg: 6,
      md: 6,
      sm: 6,
      xs: 12
    }
  },
  items: {
    outer: {
      lg: 3,
      md: 2,
      sm: 2,
      xs: 12
    },
    center: {
      lg: 6,
      md: 8,
      sm: 8,
      xs: 12
    }
  }
}

const TextSextion = styled.div`
  margin-bottom: 15px;
`

const WinItIs = styled.div`
  text-align: center;
  font-size: 1.6rem;
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  margin: 30px 0;
`

const BlueText = styled.span`
  color: ${props => props.theme.colors.primary};
`

const HeaderText = styled.span`
  color: ${props => props.theme.colors.text.header};
`

const GrayText = styled.span`
  color: ${props => props.theme.colors.text.label};
`
const LightGrayText = styled.span`
  color: ${props => props.theme.colors.text.inputPlaceholder};
`

const HomeCareers = () => {
  return (
    <Layout>
      <Grid style={{ width: '100%' }}>
        <Row>
          <Col {...LAYOUT_COLUMNS.fullCol}>
            <Center fillParent>
              <Spacer mobile={30} desktop={60} />
              <WinItIs>WinIt is a driver advocate.</WinItIs>
              <GrayText>
                <TextSextion>
                  We assist drivers with managing and disputing their parking
                  and traffic tickets.
                </TextSextion>
                <TextSextion>
                  Users simply enter their ticket details in the app, and the
                  WinIt team takes care of the rest.
                </TextSextion>
                <TextSextion>
                  With our risk free model, users only pay if we are able to
                  successfully dismiss their parking ticket.
                </TextSextion>
              </GrayText>
            </Center>
          </Col>
        </Row>
        <Row>
          <Col {...LAYOUT_COLUMNS.intro.left}>
            <Center fillParent>
              <Spacer mobile={30} desktop={60} />
              <TextSextion>
                <h3>
                  <LightGrayText>Over</LightGrayText>
                </h3>
                <h1>
                  <GrayText>100,000</GrayText>
                </h1>
                <h3>
                  <BlueText>Happy Users</BlueText>
                </h3>
              </TextSextion>
              <Spacer mobile={30} desktop={60} />
            </Center>
          </Col>
          <Col {...LAYOUT_COLUMNS.intro.right}>
            <Center fillParent>
              <Spacer mobile={30} desktop={60} />
              <TextSextion>
                <h3>
                  <LightGrayText>We saved our users over</LightGrayText>
                </h3>
                <h1>
                  <GrayText>10 Million </GrayText>
                </h1>
                <h3>
                  <BlueText>Dollars</BlueText>
                </h3>
              </TextSextion>
              <Spacer mobile={30} desktop={60} />
            </Center>
          </Col>
        </Row>
        <Row />
        <Row>
          <Col {...LAYOUT_COLUMNS.items.outer} />
          <Col {...LAYOUT_COLUMNS.items.center}>
            <Center fillParent>
              <h2>
                <HeaderText>Values</HeaderText>
              </h2>
              <List items={QUALITIES} />
            </Center>
          </Col>
          <Col {...LAYOUT_COLUMNS.items.outer} />
        </Row>
        <Row>
          <Col>
            <Spacer mobile={50} desktop={100} />
          </Col>
        </Row>
        <Row>
          <Col {...LAYOUT_COLUMNS.items.outer} />
          <Col {...LAYOUT_COLUMNS.items.center}>
            <Center fillParent>
              <h2>
                <HeaderText>Benefits</HeaderText>
              </h2>
              <List items={PERKS} />
            </Center>
          </Col>
          <Col {...LAYOUT_COLUMNS.items.outer} />
        </Row>
        <Row>
          <Col>
            <Spacer mobile={50} desktop={100} />
          </Col>
        </Row>
        <Row>
          <Col {...LAYOUT_COLUMNS.fullCol}>
            <Center fillParent>
              <h2>
                <HeaderText>Current Openings</HeaderText>
              </h2>
              <TextSextion>
                <h3>
                  <Link
                    href="https://angel.co/company/winit-app"
                    target="_blank"
                    rel="noopener noreferrer"
                  >View our AngelList page
                  </Link>
                </h3>
              </TextSextion>

            </Center>
          </Col>
        </Row>
      </Grid>
    </Layout>
  )
}

export default HomeCareers
